import React from 'react';

const UserIcon: React.FC = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="rgba(255, 255, 255, 0.05)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="46" rx="23" fill="white" fillOpacity="0.05" />
      <path
        d="M23 31C27.1421 31 30.5 27.6421 30.5 23.5C30.5 19.3579 27.1421 16 23 16C18.8579 16 15.5 19.3579 15.5 23.5C15.5 27.6421 18.8579 31 23 31Z"
        fill="white"
      />
      <path
        d="M23 33.4989C16.7896 33.5058 11.7569 38.5385 11.75 44.7489C11.75 45.4393 12.3096 45.9989 13 45.9989H33C33.6903 45.9989 34.2499 45.4393 34.2499 44.7489C34.2431 38.5385 29.2104 33.5058 23 33.4989Z"
        fill="white"
      />
    </svg>
  );
};

export default UserIcon;
